//
// Copyright (c) 2011-2025 by Curalate, Inc.
//

import {
  useAdobeOAuthSettingsQuery,
  useAdobeWebServiceSettingsQuery,
  useGoogleAnalytics4SettingsQuery,
  useGoogleAnalyticsSettingsQuery,
  useVibePixelSettingsQuery,
} from '@account-settings/accountSettingsQueries';
import { isDefined } from '@utils/filterPredicates';
import {
  OnboardingStepInfo,
  OnboardingStepStatus,
} from '@welcome-page/constants/OnboardingConstants';

export function useOnboardingAnalyticsStepInfo(): OnboardingStepInfo {
  const {
    data: isGAConnected,
    isError: isGAError,
    isLoading: isGALoading,
  } = useGoogleAnalyticsSettingsQuery((data) =>
    isDefined(data.currentProfileId),
  );

  const {
    data: isGA4Connected,
    isError: isGA4Error,
    isLoading: isGA4Loading,
  } = useGoogleAnalytics4SettingsQuery((data) =>
    isDefined(data.currentPropertyId),
  );

  const {
    data: isAdobeWSConnected,
    isError: isAdobeWSError,
    isLoading: isAdobeWSLoading,
  } = useAdobeWebServiceSettingsQuery((data) => data.isConnected);

  const {
    data: isAdobeOAuthConnected,
    isError: isAdobeOAuthError,
    isLoading: isAdobeOAuthLoading,
  } = useAdobeOAuthSettingsQuery((data) => data.isConnected);

  const {
    data: isVibePixelConnected,
    isError: isVibePixelError,
    isLoading: isVibePixelLoading,
  } = useVibePixelSettingsQuery((data) => data.isActive);

  return {
    status:
      !!isGAConnected ||
      !!isGA4Connected ||
      !!isAdobeWSConnected ||
      !!isAdobeOAuthConnected ||
      !!isVibePixelConnected
        ? OnboardingStepStatus.COMPLETE
        : OnboardingStepStatus.INCOMPLETE,
    isError:
      isGAError ||
      isGA4Error ||
      isAdobeWSError ||
      isAdobeOAuthError ||
      isVibePixelError,
    isLoading:
      isGALoading ||
      isGA4Loading ||
      isAdobeWSLoading ||
      isAdobeOAuthLoading ||
      isVibePixelLoading,
  };
}
